import {Button, Card, Form, Icon, Input, Spin} from 'antd';
import React from "react";
import {getFormFieldByType, sanitizeFieldName} from "../../util/methods";

let id = 1;

class Create extends React.Component {

  componentDidMount() {
    const {match, fetch} = this.props;
    if(match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps && nextProps.data && nextProps.data._id && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      if(nextProps.data.content && nextProps.data.content.length)
        id = nextProps.data.content.length;
    }
  }

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if(err) {
        return console.log(err);
      }
      if(values.contentName && values.contentName.length) {
        values.content = values.contentName.map((c, index) => {
          if(c) {
            return {
              name: c,
              code: values.contentCode && values.contentCode[index] || '',
            }
          }
        });
      }
      if(values.content && values.content.length)
        values.content = values.content.filter(n => n);
      if(match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  remove = k => {
    const {form} = this.props;
    // can use data-binding to get
    const keys = form.getFieldValue('keys');
    // We need at least one passenger
    if(keys.length === 1) {
      return;
    }

    // can use data-binding to set
    form.setFieldsValue({
      keys: keys.filter(key => key !== k),
    });
  };

  add = () => {
    const {form} = this.props;
    // can use data-binding to get
    const keys = form.getFieldValue('keys');
    const nextKeys = keys.concat(id++);
    // can use data-binding to set
    // important! notify form to detect changes
    form.setFieldsValue({
      keys: nextKeys,
    });
  };

  render() {
    const {getFieldDecorator, getFieldValue} = this.props.form;
    const {data, loading, filters, title, resource} = this.props;
    console.log(data);
    const hasContent = getFieldValue('hasContent');
    const isCodeRequired = getFieldValue('isCodeRequired');
    getFieldDecorator('keys', {initialValue: hasContent ? (data.content && data.content.length) ? data.content.map((_, inx) => inx) : [0] : []});
    console.log(hasContent, isCodeRequired);
    const keys = getFieldValue('keys');
    const formItems = keys.map((k, index) => (

      <div style={{width: '100%', display: 'flex'}}>
        <Form.Item
          // label={`Content ${index + 1} Name`}
          required={false}
          key={k}
          style={{width: '30%'}}
        >
          {getFieldDecorator(`contentName[${k}]`, {
            initialValue: data.content && data.content.length && data.content[k] && data.content[k].name,
            validateTrigger: ['onChange', 'onBlur'],
            rules: [
              {
                required: true,
                whitespace: true,
                message: "Please enter content name value or delete this field.",
              },
            ],
          })(<Input prefix={<Icon type="mail"/>} placeholder="Content Name value"
                    style={{marginRight: 8}}/>)}
        </Form.Item>
        {/*</Col>*/}
        {/*<Col xs={20} sm={20} md={10} lg={10} xl={10}>*/}
        {isCodeRequired &&
        (<Form.Item
          // label={`Content ${index + 1} Code`}
          required={false}
          key={k + 'C'}
          style={{width: '30%'}}
        >
          {getFieldDecorator(`contentCode[${k}]`, {
            initialValue: data.content && data.content.length && data.content[k] && data.content[k].code,
            validateTrigger: ['onChange', 'onBlur'],
            rules: [
              {
                required: true,
                whitespace: true,
                message: "Please enter content code or delete this field.",
              },
            ],
          })(<Input prefix={<Icon type="qrcode"/>} placeholder="Content Code value"
                    style={{marginRight: 8}}/>)}
        </Form.Item>)}
        <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        {keys.length > 1 ? (
          <Icon
            className="dynamic-delete-button"
            type="minus-circle-o"
            onClick={() => this.remove(k)}
          />
        ) : null}
        </span>
      </div>
    ));

    const formItemsWithButton = (<>
      <div style={{borderTop: '1px dashed', marginTop: '10px'}}>&nbsp;</div>
      {formItems}
      <Form.Item style={{width: '100%'}}>
        <Button type="dashed" onClick={this.add} style={{width: '60%'}}>
          <Icon type="plus"/> Add More Content
        </Button>
      </Form.Item>
    </>);

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="inline">

            {Object.keys(filters).map((item) => {
              if(item === 'name' || item === 'isCodeRequired' || item === 'hasContent') {
                return getFormFieldByType(filters, item, getFieldDecorator, data)
              }
            })}

            <div>
              {hasContent && formItemsWithButton}
            </div>

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
